var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8734 8.74074C15.8734 4.90554 12.6609 1.72222 8.80621 1.72222C4.95149 1.72222 1.73905 4.90554 1.73905 8.74074C1.73905 12.5759 4.95149 15.7593 8.80621 15.7593C12.6609 15.7593 15.8734 12.5759 15.8734 8.74074ZM0.500244 8.74074C0.500244 4.13149 4.15347 0.5 8.80621 0.5C13.459 0.5 17.1122 4.13149 17.1122 8.74074C17.1122 13.35 13.459 16.9815 8.80621 16.9815C4.15347 16.9815 0.500244 13.35 0.500244 8.74074Z",
    fill: "#00C8D5",
    stroke: "#00C8D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 19.9999L13.8809 13.9258",
    stroke: "#00C8D5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.239cf8b8024b69cd3e511387cfc01b41.svg";
export { ForwardRef as ReactComponent };